export interface AnalyticsPersonProperties {
    user_id?: string;
    email?: string;
    name?: string;
    subscription_tier?: 'free' | 'professional' | 'premium' | string;
    [key: string]: string | number | boolean | null | undefined;
}

export type AnalyticsEventProperties = Record<string, string | number | boolean | null | undefined>;

export const ANALYTICS_BLOCKED_KEYS = [
    'password',
    'token',
    'accessToken',
    'refreshToken',
    'authorization',
    'otp',
    'verificationCode',
    'ssn',
] as const;